// The base IP address of the wireless access point's HTTP API, operating on port 81
export const BASE_IPV4_ADDRESS = 'http://10.231.227.81';

// Use this constant to adjust the buffer time after wifi connection/disconnection --
// -- this helps ensure subsequent wifi commands  work as expected
export const WAIT_FOR_NATIVE_WIFI_MS = 6_000;
